import { Languages } from "@app/types/multilingual"

interface translation {
    CallDriver: string,
    OrderDetails: string,
    PickupAt: string,
    FinishAt: string,
    TrackYourOrder: string,
    CheckTheStatus: string,
    TypeTrackNumber: string,
    TypeNoSpace: string,
    Track: string,
    EditTrackNumber: string,
    orderNotFound: string,
    orderExpired: string,
    Block: string,
    Floor: string,
    Room: string,
    StopsLeftToDeliver: string,
    Delivering: string,
    PickingUpTheOrder: string,
    Pickup: string,
    Dropoff: string,
    ViewProof: string,
    ProofOfPickup: string,
    ProofOfDelivery: string,
}

export const tStore : {
    [key in  Languages]: translation;
} = {
    en: {
        CallDriver: 'Call Driver',
        OrderDetails: 'Order Details',
        PickupAt: 'Pickup at',
        FinishAt: 'Finish at',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Block",
        Floor: "Floor",
        Room: "Room",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    fa: {
        CallDriver: 'تماس با راننده',
        OrderDetails: 'جزییات سفارش',
        PickupAt: 'Pickup at',
        FinishAt: 'Finish at',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "بلوک",
        Floor: "طبقه",
        Room: "واحد",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    de: {
        CallDriver: 'Fahrer anrufen',
        OrderDetails: 'Bestelldetails',
        PickupAt: 'Pickup at',
        FinishAt: 'Finish at',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Gebäude",
        Floor: "Etage",
        Room: "Zimmer",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    ckb: {
        CallDriver: 'پەیوەندی بە شۆفێرەوە بکە',
        OrderDetails: 'وردەکارییەکانی داواکاری',
        PickupAt: 'Pickup at',
        FinishAt: 'Finish at',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Block",
        Floor: "Floor",
        Room: "Room",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    fr: {
        CallDriver: 'Contacter le coursier',
        OrderDetails: 'Détails de la commande',
        PickupAt: 'Récupéré à',
        FinishAt: 'Terminé à',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Bloquer",
        Floor: "Etage",
        Room: "Salle",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    ar: {
        CallDriver: 'اتصل بالسائق',
        OrderDetails: 'تفاصيل الطلب',
        PickupAt: 'الاستلام في',
        FinishAt: 'إنهاء في',
        TrackYourOrder: "تتبع طلبك",
        CheckTheStatus: "تحقق من حالة وموقع طلباتك",
        TypeTrackNumber: "اكتب رقم التتبع هنا",
        TypeNoSpace: "اكتبه بدون مسافات بين الأحرف",
        Track: "تتبع",
        EditTrackNumber: "تعديل رقم التتبع",
        orderNotFound: "الطلب غير موجود",
        orderExpired: "رقم التتبع منتهي الصلاحية",
        Block: "المبنى",
        Floor: "الطابق",
        Room: "الغرفة",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    zh: {
        CallDriver: '呼叫司机',
        OrderDetails: '订单详细信息',
        PickupAt: 'Pickup at',
        FinishAt: 'Finish at',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Block",
        Floor: "Floor",
        Room: "Room",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    ro: {
        CallDriver: 'Sună curierul',
        OrderDetails: 'Comanda Detalii',
        PickupAt: 'Pickup at',
        FinishAt: 'Finish at',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Block",
        Floor: "Floor",
        Room: "Room",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    nl: {
        CallDriver: 'Bel koerier',
        OrderDetails: 'Bestel Details',
        PickupAt: 'Pickup at',
        FinishAt: 'Finish at',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Block",
        Floor: "Floor",
        Room: "Room",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    fi: {
        CallDriver: 'Soita Kuljettajalle',
        OrderDetails: 'Tilauksen tiedot',
        PickupAt: 'Pickup at',
        FinishAt: 'Finish at',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Block",
        Floor: "Floor",
        Room: "Room",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    es: {
        CallDriver: 'Llamar al conductor',
        OrderDetails: 'Detalles del pedido',
        PickupAt: 'Pickup at',
        FinishAt: 'Finish at',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Bloque/Edificio",
        Floor: "Piso",
        Room: "Cuarto",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    it: {
        CallDriver: `Chiama l'autista`,
        OrderDetails: `Dettagli dell'ordine`,
        PickupAt: 'Pickup at',
        FinishAt: 'Finish at',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Block",
        Floor: "Floor",
        Room: "Room",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    az: {
        CallDriver: `Sürücüyə zəng et`,
        OrderDetails: `Sifariş detalları`,
        PickupAt: 'Götürmək',
        FinishAt: 'Bitirmək',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Blok",
        Floor: "Mərtəbə",
        Room: "Mənzil",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    ru: {
        CallDriver: 'Позвонить водителю',
        OrderDetails: 'Order Details',
        PickupAt: 'Взять',
        FinishAt: 'Завершить',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Block",
        Floor: "Floor",
        Room: "Room",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    tr: {
        CallDriver: `Sürücüyə zəng et`,
        OrderDetails: `Sifariş detalları`,
        PickupAt: 'Götürmək',
        FinishAt: 'Bitirmək',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Block",
        Floor: "Floor",
        Room: "Room",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    pt: {
        CallDriver: 'Ligar para entregador',
        OrderDetails: 'Order Details',
        PickupAt: 'Recolha em',
        FinishAt: 'Acabar em',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Block",
        Floor: "Floor",
        Room: "Room",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    el: {
        CallDriver: 'Κλήση Οδηγού',
        OrderDetails: 'Λεπτομέρειες Παραγγελίας',
        PickupAt: 'Παραλαβή στις',
        FinishAt: 'Ολοκλήρωση σε',
        TrackYourOrder: "Εντοπισμός Διανομής",
        CheckTheStatus: "Ελέγξτε την κατάσταση και την τοποθεσία των παραγγελιών σας",
        TypeTrackNumber: "Πληκτρολογήστε εδώ τον αριθμό παρακολούθησης",
        TypeNoSpace: "Πληκτρολογήστε χωρίς κενό μεταξύ των χαρακτήρων",
        Track: "Εντοπισμός",
        EditTrackNumber: "Επεξεργασία αριθμού παρακολούθησης",
        orderNotFound: "Η παραγγελία δεν υπάρχει",
        orderExpired: "Ο κωδικός παρακολούθησης έχει λήξει ",
        Block: "Οικοδομικό τετράγωνο",
        Floor: "Όροφος",
        Room: "Δωμάτιο",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    'de-AT': {
        CallDriver: 'Call Driver',
        OrderDetails: 'Order Details',
        PickupAt: 'Pickup at',
        FinishAt: 'Finish at',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Stiege",
        Floor: "Stock",
        Room: "Türnummer",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    ku: {
        CallDriver: 'پەیوەندیکردن لەگەڵ شۆفێر',
        OrderDetails: 'Order Details',
        PickupAt: 'Pickup at',
        FinishAt: 'Finish at',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Block",
        Floor: "Floor",
        Room: "Room",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    he: {
        CallDriver: 'Call Driver',
        OrderDetails: 'Order Details',
        PickupAt: 'Pickup at',
        FinishAt: 'Finish at',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "בלוק",
        Floor: "קומה",
        Room: "חדר",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    hi: {
        CallDriver: 'Call Driver',
        OrderDetails: 'Order Details',
        PickupAt: 'Pickup at',
        FinishAt: 'Finish at',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "ब्लॉक",
        Floor: "मंजिल",
        Room: "कमरा",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    ms: {
        CallDriver: 'Call Driver',
        OrderDetails: 'Order Details',
        PickupAt: 'Pickup at',
        FinishAt: 'Finish at',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Block",
        Floor: "Floor",
        Room: "Room",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    "pt-BR": {
        CallDriver: 'Chamar Motorista',
        OrderDetails: 'Detalhes do Pedido',
        PickupAt: 'Retirar em',
        FinishAt: 'Finalizar em',
        TrackYourOrder: "Rastreie seu pedido",
        CheckTheStatus: "Verifique o status e a localização dos seus pedidos",
        TypeTrackNumber: "Digite seu número de rastreamento aqui",
        TypeNoSpace: "Digite sem espaço entre os caracteres",
        Track: "Rastrear",
        EditTrackNumber: "Editar número de rastreamento",
        orderNotFound: "O pedido não existe",
        orderExpired: "O número de rastreamento expirou",
        Block: "Block",
        Floor: "Floor",
        Room: "Room",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    cs: {
        CallDriver: 'Call Driver',
        OrderDetails: 'Order Details',
        PickupAt: 'Pickup at',
        FinishAt: 'Finish at',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Blok",
        Floor: "Patro",
        Room: "Pokoj",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    hu: {
        CallDriver: 'Call Driver',
        OrderDetails: 'Order Details',
        PickupAt: 'Pickup at',
        FinishAt: 'Finish at',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Épülettömb",
        Floor: "Emelet",
        Room: "Szoba",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    ka: {
        CallDriver: 'Call Driver',
        OrderDetails: 'Order Details',
        PickupAt: 'Pickup at',
        FinishAt: 'Finish at',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Block",
        Floor: "Floor",
        Room: "Room",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    km: {
        CallDriver: 'Call Driver',
        OrderDetails: 'Order Details',
        PickupAt: 'Pickup at',
        FinishAt: 'Finish at',
        TrackYourOrder: "Track your order",
        CheckTheStatus: "Check the status and location of your orders",
        TypeTrackNumber: "Type your track number here",
        TypeNoSpace: "Type it with no space between characters",
        Track: "Track",
        EditTrackNumber: "Edit track number",
        orderNotFound: "The order doesn’t exist",
        orderExpired: "Tracking number is expired",
        Block: "Block",
        Floor: "Floor",
        Room: "Room",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    },
    et: {
        CallDriver: 'Helista juhile',
        OrderDetails: 'Tellimuse üksikasjad',
        PickupAt: 'Võta vastu aadressil',
        FinishAt: 'Lõpeta aadressil',
        TrackYourOrder: "Jälgi oma tellimust",
        CheckTheStatus: "Kontrolli oma tellimuste staatust ja asukohta",
        TypeTrackNumber: "Sisesta jälgimisnumber siia",
        TypeNoSpace: "Sisesta ilma tühikuteta",
        Track: "Jälgi",
        EditTrackNumber: "Muuda jälgimisnumbrit",
        orderNotFound: "Tellimust ei eksisteeri",
        orderExpired: "Jälgimisnumber on aegunud",
        Block: "Plokk",
        Floor: "Korrus",
        Room: "Tuba",
        StopsLeftToDeliver: "Stops Left to Deliver",
        Delivering: "Delivering",
        PickingUpTheOrder: "Picking up the order",
        Pickup: "Pickup",
        Dropoff: "Dropoff",
        ViewProof: "View Proof",
        ProofOfPickup: "Proof of Pickup",
        ProofOfDelivery: "Proof of Delivery"
    }
}

export const t = (key : keyof translation , language : Languages)=>{
    if(tStore[language] && tStore[language][key]) return tStore[language][key]
    else return tStore['en'][key]
}